 //export const API = "https://rinconclub.tk/gescom"
 //export const API = "http://localhost:8001/gescom"
 //export const API = "https://rincon-club.tk/gescom"
 export const API = "https://rinconclub.uy/gescom"
 //export const HOST = "https://rinconclub.tk"
 //export const HOST = "http://localhost:8001"
 //export const HOST = "https://rincon-club.tk"
 export const HOST = "https://rinconclub.uy"
 export const SPINNER = '<div class="fixed-bottom text-end"><span class="bg-danger px-2">Cargando...</span></div>'
 export const http_headers = {
    'Accept': 'application/json, text/plain, */*',
    'Content-Type': 'application/json',
    'authorization': 'xxx'
}

export const control = {
   'api2' : 'https://rinconclub.uy/gescom',
   'api' : 'http://localhost:8001/gescom',
   'tabname' : 'dummy',
   'page' : 0,
   'rpp' : 20,
   'pkname' : '',
   'update' : false,
   'loading' : false,
   'headers' : {
      'Accept': 'application/json, text/plain, */*',
      'Content-Type': 'application/json',
      'authorization': 'xxx'     
   }
}

export const acListCheck = (permiso) => {
   //if(permiso==='CAJA') return true
   let gscUser = getGscUser()
   let permisos = gscUser.aclist.split(',')
   //console.log(permisos)
   return permisos.includes(permiso) || false
}

export const getLoggedUser = () => {
   let gscUser = getGscUser()
   return gscUser.username || ''
}

export const toDate = (d) => {
  if(!d || d.length<10) return { fecha:'01/01/1901', hora:'00:00:00'}
  let fecha = d.substr(0,10) || ''
  let hora = d.substr(11,8) || ''
  if(fecha==='' || hora==='') return { fecha:'' , hora:''}
  return { fecha : fecha.split('-').reverse().join('/') , hora: hora}
}

export const get_semanas = (aYear) => {
   let semanas = []
   let un_dia = 24*60*60*1000
   let una_semana = 7 * un_dia

   let fdoy = (new Date(aYear.toString()+'-01-01')) //.toISOString()
   let hoy = (new Date()).getTime()
   let fdofw = fdoy.getTime()

   let control = 0
   while((new Date(fdofw)).getDay()!==5 ){
      fdofw += un_dia
      control++
   }
   //console.log(control, fdofw)
   for(let i=0; i<53; i++){
      let aux = new Date(fdofw+((i*7))*un_dia)
      if(parseInt(aux.toISOString().substr(0,4)) <= aYear){
         let sa = aux
         let vi = new Date(fdofw+((i*7)+6)*un_dia)
         let sa2 = new Date(fdofw+((i*7)+7)*un_dia) //new Date(fdofw-1+((i*7)+7)*un_dia)
         semanas.push({semana:i+1,sa:sa.toISOString().substr(0,10),vi:vi.toISOString().substr(0,10),
                  sa2:sa2.toISOString().substr(0,10),
                  actual : (hoy>=sa.getTime() && hoy<=sa2.getTime())
               })
      }
   }
   //console.log(semanas)
   return semanas
}

export const get_pundia = (aYear) => {
   
}

const getGscUser = () => {
      let name = "gsc-user=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(';');
      for(let i = 0; i <ca.length; i++) {
       let c = ca[i];
       while (c.charAt(0) == ' ') {
         c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
         let cookie = c.substring(name.length, c.length);
         //console.log(JSON.parse(cookie))
         return JSON.parse(cookie)
      }
   }
   return {};
}